export const multiColorStripGradient = `linear-gradient(left, rgba(8,81,159,1) 10%, rgba(0,187,255,1) 33%, rgba(182,235,7,1) 63%, rgba(237,151,3,1) 93%)`;
export const multiColorStripBottomGradient = `linear-gradient(top, rgba(8,81,159,1) 10%, rgba(0,187,255,1) 33%, rgba(182,235,7,1) 63%, rgba(237,151,3,1) 93%)`;
